import script from "./ArticleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleModal.vue?vue&type=script&setup=true&lang=js"

import "./ArticleModal.vue?vue&type=style&index=0&id=495d39ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-495d39ab"]])

export default __exports__